import { lazyRouteComponent } from "@tanstack/react-router";
import { Newspaper } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const TABS = ["announcements", "meetings"] as const;
export const SCOPES = ["all", "nifty500", "watchlist"] as const;
export const DAYS = [1, 7, 30] as const;

export interface NewsSearch {
  tab: (typeof TABS)[number];
  scope: (typeof SCOPES)[number];
  /** Symbol starts with. */
  q?: string;
  /** Announcement category (results, dividend, ...). */
  cat?: string;
  days: (typeof DAYS)[number];
}

export function parseNewsSearch(s: Record<string, unknown>): NewsSearch {
  const q = typeof s.q === "string" && /^[A-Za-z0-9&_-]{1,30}$/.test(s.q) ? s.q.toUpperCase() : undefined;
  const cat = typeof s.cat === "string" && /^[a-z_]{1,40}$/.test(s.cat) ? s.cat : undefined;
  const days = Number(s.days);
  return {
    tab: TABS.includes(s.tab as NewsSearch["tab"]) ? (s.tab as NewsSearch["tab"]) : "announcements",
    scope: SCOPES.includes(s.scope as NewsSearch["scope"]) ? (s.scope as NewsSearch["scope"]) : "all",
    ...(q ? { q } : {}),
    ...(cat ? { cat } : {}),
    days: (DAYS as readonly number[]).includes(days) ? (days as NewsSearch["days"]) : 7,
  };
}

export const pages: PageDef[] = [
  {
    path: "/app/news",
    title: "News",
    component: lazyRouteComponent(() => import("./NewsPage"), "NewsPage"),
    nav: { label: "News", icon: Newspaper, group: "Markets", order: 50 },
    validateSearch: parseNewsSearch,
  },
];
